import MultiStepForm from '@/components/forms/MultiStepForm';
import WeclappInterfaceForm from '@/components/forms/apps/WeclappInterfaceForm';
import TanssInterfaceForm from '@/components/forms/apps/TanssInterfaceForm';
import TanssERPInterfaceForm from '@/components/forms/apps/TanssERPInterfaceForm';
import Templates from '@/components/forms/apps/tanss2weclapp/Templates';
import Invoices from '@/components/forms/apps/tanss2weclapp/Invoices';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';
import { Box } from '@mui/system';

export default function Tanss2WeclappSetup({
  app,
  onFinish,
  onCancel,
  deployment,
}) {
  const depl = deployment || {};

  const steps = [
    <WeclappInterfaceForm key="weclappInterface" app={app} />,
    <TanssInterfaceForm key="tanssInterface" app={app} />,
    <TanssERPInterfaceForm key="tanssERPInterface" app={app} />,
    <Templates key="templates" app={app} />,
    <Invoices key="invoices" app={app} />,
  ];

  const handleSubmit = async (formData) => {
    const deploymentData = {
      config: formData,
    };
    try {
      await tenant.put(`/deployment/${depl.insertedId}`, deploymentData);

      onFinish();
    } catch (error) {
      console.error('Error during deployment update:', error);
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <MultiStepForm
        steps={steps}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </Box>
  );
}
